<template>
  <div>
    <el-dialog title="上传图片" v-model="visible" width="970px" :before-close="handleClose">
      <upload-index v-if="visible" :is-more="isMore" @getImage="getImage" />
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import { ref } from 'vue';
// @ts-ignore SFC 默认导出由编译器生成
import UploadIndex from '@/components/uploadPictures/index.vue';

// 类型定义
interface UploadCallback {
  (images: string[]): void;
}

// 响应式数据
const visible = ref(false);
const callback = ref<UploadCallback>(() => { });
const isMore = ref<string>('');

// 方法
const handleClose = () => {
  visible.value = false;
};

const getImage = (img: string[]) => {
  callback.value(img);
  visible.value = false;
};

const openUpload = (fn: UploadCallback, more: string) => {
  callback.value = fn;
  isMore.value = more;
  visible.value = true;
};

// 暴露给父组件的方法
defineExpose({
  openUpload,
  handleClose,
  getImage,
  visible,
  callback,
  isMore
});
</script>

<style scoped></style>
